import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Calendar, Users, ArrowRight, Briefcase, BookOpen, HeartPulse } from "lucide-react";
import { Link } from "wouter";

export default function LongevityGuild() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="bg-indigo-950 text-white py-16 md:py-24">
        <div className="container mx-auto px-4 max-w-5xl">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-serif font-medium mb-6 leading-tight tracking-tight">
              The Longevity Guild
            </h1>
            <div className="h-px bg-indigo-300/30 w-16 mx-auto mb-8"></div>
            <p className="text-sm text-indigo-100 max-w-2xl mx-auto mb-8 leading-relaxed">
              A community of clinicians, entrepreneurs, and investors dedicated to advancing the practice of longevity medicine through evidence-based protocols and collaborative innovation.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button className="bg-white text-indigo-950 hover:bg-gray-100 text-xs px-6 py-2 rounded-sm h-auto">
                Apply for Membership
              </Button>
              
              <a href="https://calendar.notion.so/meet/anant-wje3h1hoi/sn2go4gd4" target="_blank" rel="noopener noreferrer">
                <Button variant="outline" className="border-white text-white hover:bg-white/10 text-xs px-6 py-2 rounded-sm h-auto">
                  Book a Discovery Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Coming Soon Section */}
      <div className="py-16 container mx-auto px-4 max-w-5xl">
        <div className="mb-8">
          <h2 className="text-2xl font-serif font-medium mb-2 text-center">
            Coming Soon
          </h2>
          <div className="h-px bg-indigo-900/30 w-16 mx-auto mb-4"></div>
          <p className="text-sm text-gray-700 max-w-2xl mx-auto text-center mb-12">
            The Longevity Guild is currently in development. Join our waitlist to be notified when we launch.
          </p>
        </div>
          
        <div className="mb-16">
          <h3 className="text-lg font-medium mb-6 text-gray-900">What to Expect</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow">
              <p className="text-[11px] uppercase tracking-wider text-indigo-900 font-medium mb-4">01</p>
              <h4 className="text-base font-medium mb-3 text-gray-900">For Patients</h4>
              <p className="text-sm text-gray-700 leading-relaxed">
                Access to cutting-edge longevity protocols, personalized guidance, and a community of like-minded individuals.
              </p>
            </div>
            
            <div className="border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow">
              <p className="text-[11px] uppercase tracking-wider text-indigo-900 font-medium mb-4">02</p>
              <h4 className="text-base font-medium mb-3 text-gray-900">For Clinics</h4>
              <p className="text-sm text-gray-700 leading-relaxed">
                Implementation guides, business frameworks, and operational support to scale your longevity practice.
              </p>
            </div>
            
            <div className="border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow">
              <p className="text-[11px] uppercase tracking-wider text-indigo-900 font-medium mb-4">03</p>
              <h4 className="text-base font-medium mb-3 text-gray-900">For Learners</h4>
              <p className="text-sm text-gray-700 leading-relaxed">
                Comprehensive educational resources, clinical protocols, and scientific updates in longevity medicine.
              </p>
            </div>
          </div>
        </div>
          
        <div className="max-w-md mx-auto">
          <div className="border border-indigo-200 bg-white p-6 shadow-sm">
            <h3 className="text-base font-medium mb-3 text-gray-900">Join the Waitlist</h3>
            <p className="text-sm text-gray-700 mb-6 leading-relaxed">
              Be the first to know when the Longevity Guild launches. Enter your email below.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="flex-1 px-4 py-2 rounded-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-indigo-500 text-sm"
              />
              <Button className="bg-indigo-950 text-white hover:bg-indigo-900 text-xs px-4 py-2 rounded-sm h-auto">
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}